import script from "./OnboardingAiResearchTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiResearchTable.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiResearchTable.vue?vue&type=style&index=0&id=3b734658&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b734658"]])

export default __exports__